import axios from 'axios';
import request from "arcdynamic-request";
import { mutateData } from '../components/Service/graphQlService';
import { UPLOAD_IMAGE } from '../components/Graphql/Mutations/FileUploadMutation';
import { DELETE_IMAGE } from '../components/Graphql/Mutations/FileDeleteMutation';

// upload file to arc
export function uploadFile({fileName, base64File, folder,type="image"}) {
    const imageinput = {
        imageData : base64File,
        filename:fileName,
        folder,
        type
      }
    // return axios({
    //     withCredentials:true,
    //     method: 'post',
    //     url: arc.path.api,
    //     headers: {'Accept': '*', 'Content-Type':'application/json'},
    //     data: {
    //         id:1,
    //         requests: [{
    //             service:"arcimedes",
    //             action:"open.File.update",
    //             params: [
    //                 base64File,
    //                 fileName,
    //                 folder,
    //                 true,
    //             ]
    //         }]
    //     }
    // })
    return mutateData(UPLOAD_IMAGE,{"input":imageinput})
};

//remove file from arc
export function removeFile(fileName){
    // return request(arc.path.api, {
    //     service: "arcimedes",
    //     action: "open.File.purge",
    //     params: [
    //         fileName, 
    //         folder, 
    //         "public"
    //     ]
    // });
    return mutateData(DELETE_IMAGE, { "id": fileName });
}